import React, { useEffect, useContext, useState, useRef } from 'react'
import _ from "lodash"

import {
  Hidden,
  Box,
} from '@mui/material'

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ScansContext from "../../contexts/ScansContext"


const SoftSkillsWrapper = ({ softSkills }) => {

  const theme = useTheme();

  const { colorByFamily } = useContext(ScansContext)

  const refContainer = useRef(null)

  const [isWrapping, setIsWrapping] = useState(false)
  const [nbrWrapped, setNbrWrapped] = useState(0)
  const [xForBox, setXForBox] = useState(0)

  useEffect(() => {
    if (softSkills) {
      const observer = new ResizeObserver(_.debounce(entries => {
        for (const entry of entries) {
          let width =  entry.contentRect.width
          let height = entry.contentRect.height
          let allTops = []
          let allChilds = []
          for (let i = 0; i < entry?.target?.children?.length; ++i) {
            let child = entry?.target?.children[i]
            if (child?.classList?.value?.includes("ignore") !== true) {
              allTops.push(child.getBoundingClientRect()?.top)
              allChilds.push(child.getBoundingClientRect())
            }

          }


          let uniqueTops = [...new Set(allTops)];
          if (uniqueTops?.length > 1) {
            let firstTop = allTops[0]
            let nbrTotal = allTops?.length
            let firstRow = allChilds.filter((el) => el?.top === firstTop)
            let allWidth = 0
            let flexGap = 7
            firstRow.forEach((el) => {
              allWidth+= el.width + flexGap
            })
            setXForBox(allWidth)

            let otherTops = allTops?.filter((el) => el !== firstTop)
            setNbrWrapped(otherTops?.length)
            setIsWrapping(true)
          } else {
            setIsWrapping(false)
            setNbrWrapped(0)
          }

        }
      }))
      observer.observe(refContainer.current)
      return () => {
        observer.disconnect();
      }
    }
  }, [softSkills])


  return (
    <>
      <Box ref={refContainer} sx={{display:"flex", flexWrap:"wrap", columnGap:"7px", rowGap:"20px", marginTop:"5px", position:"relative"}}>
        {softSkills?.map((skill, index) => {
          let color = colorByFamily?.find((el) => el.family === skill?.family)
          return (
            <Box
              key={index}
              sx={{
                fontSize:["10px", "11px", "12px"],
                fontWeight:500,
                padding:["7px", "8px", "9px"],
                flexShrink:0,
                background : color?.bg,
                color: color?.text,
                border: `1px solid ${color?.border}`,
                textTransform:"uppercase",
                userSelect:"none",
              }}
            >
              {skill?.key}
            </Box>
          )
        })}
        {isWrapping &&
          <Box
            className="ignore"
            sx={{
              position:"absolute",
              zindex:2,
              top:0,
              left:`${xForBox}px`,
              fontSize:["10px", "11px", "12px"],
              fontWeight:500,
              padding:["7px", "8px", "9px"],
              flexShrink:0,
              background : "#F5F5F5",
              color: "#969696",
              border: `1px solid #969696`,
              textTransform:"uppercase",
              userSelect:"none",
              whiteSpace:"nowrap",
            }}
          >
            + {nbrWrapped}
          </Box>
        }
      </Box>
      {isWrapping &&
        <Box sx={{marginTop:"5px"}}>
          <Box
            sx={{
              fontSize:["10px", "11px", "12px"],
              fontWeight:500,
              padding:["7px", "8px", "9px"],
              flexShrink:0,
              background : "#F5F5F5",
              color: "#969696",
              border: `1px solid #969696`,
              textTransform:"uppercase",
              userSelect:"none",
              whiteSpace:"nowrap",
              visibility:"hidden"
            }}
          >
            + {nbrWrapped}
          </Box>

        </Box>
      }
    </>
  )
}


export default SoftSkillsWrapper
